export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'Accueil',
    garage: 'Systèmes de garage',
    villa: 'Projets de villa',
    winter: "Jardin d'hiver",
    projects: 'Projets',
    about: 'À propos',
    contact: 'Contact',
    cta: 'Demander un devis pour votre projet',
  },
  hero: {
    title1: 'Systèmes de garage premium',
    title2: 'qui valorisent votre villa',
    subtitle: 'Solutions de garage fermé premium, conçues sur mesure pour les projets de villa de luxe et les villas privées.',
    cta1: 'Demander un devis pour votre projet',
    cta2: 'Découvrir les systèmes de garage',
    small: 'Systèmes 1 & 2 véhicules • Design architectural sur mesure • Solutions par projet',
  },
  s1: {
    title: 'Un garage ne doit pas être un ajout tardif à votre villa.',
    text: 'VILLAGARAGE considère le garage non comme une structure indépendante, mais comme une partie intégrante de l’architecture de la villa.',
    f1: 'Design architectural sur mesure',
    f2: 'Apparence premium',
    f3: 'Protection du véhicule en toutes saisons',
  },
  s2: {
    title: 'Même villa. Un niveau de vie différent.',
    openTitle: 'Stationnement ouvert',
    openDesc: 'Véhicule exposé aux intempéries. Manque d’unité architecturale. N’apporte aucune valeur au projet.',
    garageTitle: 'Garage premium VILLAGARAGE',
    garageDesc: 'Véhicule protégé toute l’année. S’intègre à l’architecture de la villa. Apporte une valeur premium au projet.',
    cta: 'Demander une solution pour votre projet',
  },
  s3: {
    title: 'Systèmes de garage',
    cta: 'Découvrir',
    card1: {
      title: 'Garage premium une place',
      desc: 'Un garage premium compact, élégant et architecturalement sur mesure pour un seul véhicule.',
    },
    card2: {
      title: 'Garage premium deux places',
      desc: 'Un garage premium spacieux et lumineux qui s’intègre parfaitement à votre villa pour deux véhicules.',
    },
    card3: {
      title: 'Systèmes de garage sur mesure',
      desc: 'Des solutions sur mesure conçues pour les projets de villa et les exigences spécifiques.',
    },
  },
  s4: {
    title1: 'Aucune villa n’est identique.',
    title2: 'Leur garage non plus.',
    d1: 'Systèmes architecturaux anthracite',
    d2: 'Détails en bois naturel',
    d3: 'Éclairage architectural',
    d4: 'Designs de façade personnalisés',
    d5: 'Solutions 1 & 2 véhicules',
  },
  s5: {
    title: 'Un détail qui distingue les projets de villa',
    subtitle: 'VILLAGARAGE pour les entreprises de construction, les promoteurs et les architectes.',
    b1: 'Design par projet',
    b2: 'Intégration à l’architecture de la villa',
    b3: 'Structure adaptée aux projets multi-villas',
    b4: 'Perception premium du projet',
    b5: 'Solutions une / deux places',
    b6: 'Une approche systémique alternative aux procédés de construction lourds traditionnels',
    cta: 'Soumettre votre projet de villa',
  },
  s6: {
    title: 'Ne laissez pas votre voiture de luxe exposée toute l’année.',
    text: 'Créez un espace premium mieux protégé contre le soleil, la pluie, la grêle, la neige et les facteurs extérieurs.',
    cta: 'Je veux un garage pour ma villa',
  },
  s7: {
    title: 'Solutions architecturales holistiques pour votre villa',
    subtitle: "Garage premium + Jardin d'hiver",
    cta: 'Demander des informations pour mon projet',
  },
  s8: {
    title: 'Comment votre projet commence-t-il ?',
    step1: 'Partagez votre espace',
    step1d: 'Envoyez-nous les détails essentiels sur votre villa ou votre projet.',
    step2: 'Définir le besoin',
    step2d: 'Clarifions ensemble la capacité des véhicules et les scénarios d’utilisation.',
    step3: 'Approche de design',
    step3d: 'Développons une approche de design sur mesure adaptée à votre architecture.',
    step4: 'Devis',
    step4d: 'Fournissons un devis personnalisé selon l’étendue du projet.',
    step5: 'Mise en œuvre',
    step5d: 'Après validation, réalisons la mise en œuvre comme prévu.',
  },
  s9: {
    title: 'Projets de garage inspirants',
    filterAll: 'Tous',
    filterSingle: 'Une place',
    filterDouble: 'Deux places',
    filterVilla: 'Projets de villa',
    filterWinter: "Jardin d'hiver",
  },
  s10: {
    title: 'Concevons une solution sur mesure pour votre villa ou votre projet.',
  },
  form: {
    name: 'Nom complet',
    namePh: 'Votre nom complet',
    phone: 'Téléphone',
    phonePh: '+90 5xx xxx xx xx',
    email: 'E-mail',
    emailPh: 'exemple@email.com',
    city: 'Ville',
    cityPh: 'Votre ville',
    customerType: 'Type de client',
    solution: 'Solution qui vous intéresse',
    projectStatus: 'Statut du projet / terrain',
    message: 'Message',
    messagePh: 'Décrivez brièvement votre projet...',
    upload: "Téléversement d'image",
    uploadHint: 'Vous pouvez téléverser des images de terrain, de villa ou de référence',
    submit: 'ENVOYER MON PROJET',
    success: 'Votre demande a bien été reçue. Nous vous contacterons prochainement.',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    customer: {
      villaOwner: 'Propriétaire de villa',
      construction: 'Entreprise de construction',
      developer: 'Promoteur',
      architect: 'Architecte',
      investor: 'Investisseur',
      other: 'Autre',
    },
    solutionOpt: {
      single: 'Garage une place',
      double: 'Garage deux places',
      villaProject: 'Projet de villa',
      winterGarden: "Jardin d'hiver",
      combined: "Garage + Jardin d'hiver",
      custom: 'Projet spécial',
    },
    status: {
      land: 'Terrain disponible',
      construction: 'Villa en construction',
      existing: 'Villa existante',
      none: 'Pas encore de terrain',
      other: 'Autre',
    },
  },
  whatsapp: {
    message: 'Bonjour VILLAGARAGE, je souhaite obtenir des informations et un devis pour mon projet de villa / garage.',
  },
  mobile: {
    cta: 'Demander des informations pour votre projet',
  },
  faq: {
    title: 'Questions fréquentes',
    q1: 'Peut-il être appliqué aux villas existantes ?',
    a1: 'Oui. Nous proposons des solutions adaptées aux villas neuves comme existantes. Pour les villas existantes, une mise en œuvre sur mesure est réalisée après évaluation de l’espace et de la structure architecturale.',
    q2: 'Existe-t-il des systèmes une et deux places ?',
    a2: 'Oui, nos systèmes de garage premium une et deux places sont disponibles. Nous développons également des solutions multiples sur mesure.',
    q3: 'Le même modèle est-il appliqué à chaque villa ?',
    a3: 'Non. Chaque projet est conçu sur mesure selon l’architecture, les dimensions et les besoins du client ; aucun modèle standard n’est utilisé.',
    q4: 'Travaillez-vous sur des projets multi-villas ?',
    a4: 'Oui, nous collaborons avec des entreprises de construction et des promoteurs sur des projets multi-villas, en proposant des solutions sur mesure.',
    q5: 'Un jardin d’hiver peut-il aussi être réalisé ?',
    a5: "Oui. En plus des systèmes de garage, nous proposons des solutions de jardin d'hiver et des solutions intégrées garage + jardin d'hiver.",
    q6: 'Comment le prix est-il déterminé ?',
    a6: 'Le prix est déterminé selon les dimensions, la capacité des véhicules, les détails architecturaux, les préférences de matériaux et l’étendue du projet.',
    q7: 'Comment puis-je soumettre mon projet ?',
    a7: 'Vous pouvez remplir le formulaire sur notre site, nous joindre via WhatsApp (+90 544 110 14 92) ou envoyer un message via Instagram (@villagarage90).',
  },
  about: {
    title: 'À propos',
    text: 'VILLAGARAGE est une marque qui développe des solutions architecturales pour les garages de villa premium et les espaces de vie extérieurs. Elle considère le garage non comme une structure indépendante mais comme une partie intégrante de l’architecture de la villa, apportant une valeur durable aux espaces de vie grâce aux systèmes anthracite, aux détails en bois naturel et aux designs de façade personnalisés. En collaboration avec les propriétaires, architectes, entrepreneurs et promoteurs, elle fournit des solutions premium sur mesure, intégrées à l’architecture.',
  },
  final: {
    title: 'Complétez l’architecture de votre villa avec votre garage.',
    cta1: 'Demander un devis pour votre projet',
    cta2: 'Nous contacter sur WhatsApp',
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'Menu',
    contactTitle: 'Contact',
    instagram: 'Instagram',
    copyright: 'Tous droits réservés.',
  },
};